function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0,172v-172h172v172z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M41.495,166.625c-3.225,-5.805 -32.035,-57.62 -35.905,-116.315c-0.645,-7.095 4.085,-13.76 11.395,-15.695l25.8,-6.45c6.88,-1.72 12.685,-6.235 16.125,-12.685l5.59,-10.105h43.645l4.945,10.105c3.44,6.45 9.245,11.18 16.125,12.9l25.8,6.45c7.095,1.935 11.825,8.6 11.395,15.695c-4.085,56.33 -32.68,110.295 -35.905,116.315h-89.01z",
  fill: "#5b4e03"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.285,6.45l4.73,9.46c3.655,6.665 9.675,11.61 16.985,13.33l25.585,6.45c6.45,1.72 10.965,7.955 10.75,14.62c-4.085,54.61 -30.96,107.07 -35.475,115.24h-87.72c-4.515,-7.955 -31.82,-58.265 -35.475,-115.24c-0.645,-6.665 3.87,-12.685 10.75,-14.405l25.8,-6.45c7.31,-1.72 13.33,-6.45 16.985,-13.33l4.945,-9.675h42.14M108.79,4.3h-44.935l-5.805,10.535c-3.225,6.02 -8.6,10.535 -15.48,12.255l-25.8,6.45c-7.74,1.935 -13.115,9.03 -12.255,16.77c4.085,62.995 36.335,117.39 36.335,117.39h90.3c0,0 31.82,-56.76 36.335,-117.175c0.43,-7.74 -4.945,-14.62 -12.255,-16.77l-25.8,-6.45c-6.45,-1.72 -12.255,-6.235 -15.48,-12.255l-5.16,-10.75z",
  fill: "#dbba07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.14,29.24c-1.505,-0.43 -2.795,-0.86 -4.085,-1.505c-4.3,15.05 -18.49,30.315 -38.055,30.315c-19.78,0 -33.97,-15.265 -38.055,-30.315c-1.29,0.645 -2.58,1.075 -4.085,1.505c4.73,16.555 20.425,33.11 42.14,33.11c21.715,0 37.41,-16.555 42.14,-33.11z",
  fill: "#dbba07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.005,87.505l19.995,-21.5l19.995,21.5l-19.995,26.875z",
  fill: "#ead15f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86,67.725l18.705,19.995l-18.705,24.725l-18.705,-24.94l18.705,-19.78M86,64.5l-21.5,23.005l21.5,28.595l21.5,-28.595l-21.5,-23.005z",
  fill: "#e67e22"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.295,87.505l18.705,0.645v24.295zM86,88.15v-20.425l18.705,19.995z",
  fill: "#dbba07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86,66.65c-1.29,0 -2.15,-0.86 -2.15,-2.15v-8.6c0,-1.29 0.86,-2.15 2.15,-2.15c1.29,0 2.15,0.86 2.15,2.15v8.6c0,1.29 -0.86,2.15 -2.15,2.15z",
  fill: "#dbba07"
}));

var SvgAccessoriesIcon = function SvgAccessoriesIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: 65,
    height: 65,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _ref2, _ref3));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccessoriesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AccessoriesIcon.c8ea8a2f.svg";
export { ForwardRef as ReactComponent };